'use client';
import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { useTheme } from '@/context/ThemeContext';

interface AppLayoutProps {
  children: React.ReactNode;
  pageTitle: string;
}

export default function AppLayout({ children, pageTitle }: AppLayoutProps) {
  const [collapsed, setCollapsed] = useState(false);
  const { theme } = useTheme();
  const isLight = theme === 'light';

  return (
    <div
      className="min-h-screen"
      style={{
        background: isLight ? '#F8FAFC' : '#070D1A',
        transition: 'background 300ms ease',
      }}
    >
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((p) => !p)} />
      <Topbar pageTitle={pageTitle} collapsed={collapsed} />
      <main
        className={`pt-14 min-h-screen content-transition`}
        style={{ marginLeft: collapsed ? '64px' : '240px' }}
      >
        <div className="px-6 py-6 max-w-screen-2xl mx-auto">
          {children}
        </div>
      </main>
    </div>
  );
}